import { splitLinks } from '@/lib/linkify';

// Renders free text with any web address in it clickable (opens in a new tab).
export function Linkified({ text }: { text: string }) {
  return (
    <>
      {splitLinks(text).map((part, index) =>
        part.type === 'link' ? (
          <a
            // biome-ignore lint/suspicious/noArrayIndexKey: parts are positional and static
            key={index}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            className="break-all text-blue-600 underline hover:text-blue-800 dark:text-blue-400"
          >
            {part.text}
          </a>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: parts are positional and static
          <span key={index}>{part.text}</span>
        ),
      )}
    </>
  );
}
